(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-sidebar-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
    const PRESERVE_PARAMS = ['page', 'section_id'];

    function getActiveFilterParams() {
      const params = new URLSearchParams(window.location.search);
      PRESERVE_PARAMS.forEach((key) => params.delete(key));
      return params;
    }

    function buildFilteredUrl(baseUrl, params) {
      const url = new URL(baseUrl, window.location.origin);
      url.search = '';
      params.forEach((value, key) => {
        url.searchParams.append(key, value);
      });
      return url.pathname + url.search + url.hash;
    }

    function updateSubcategoryLinks() {
      const childLinks = document.querySelectorAll('.js-preserve-collection-filters');
      if (!childLinks.length) return;

      const params = getActiveFilterParams();
      if (!params.toString()) {
        childLinks.forEach((link) => {
          if (link.dataset.baseUrl) link.href = link.dataset.baseUrl;
        });
        return;
      }

      childLinks.forEach((link) => {
        const baseUrl = link.dataset.baseUrl || link.href.split('?')[0];
        link.href = buildFilteredUrl(baseUrl, params);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateSubcategoryLinks);
    } else {
      updateSubcategoryLinks();
    }

    document.addEventListener('on:facet-filters:updated', updateSubcategoryLinks);
  })();
  } catch(e) { console.error(e); }
})();

})();
